<template>
  <div id="home">
    <div
      style="position: absolute; top: 0px; left: 0px; width: 100%; height: 100%"
    >
      <div class="home-top">
        <div class="title-top">福建省福安市数字农业（茶叶）</div>
      </div>
      <div id="platform1" class="platform-content1">
        <div class="systemContent">
          <div class="sys-content">
            <div class="menuBox">
              <div class="menuClickBox">
                <img
                  src="https://video-1316200666.cos.ap-guangzhou.myqcloud.com/fujian/fuan/photo/1.png"
                  alt=""
                  class="menu_img"
                />
                <div class="menu_name">茶叶大数据中心</div>
                <div class="menu_name_en">Tea big data center</div>
                <div
                  class="menu_enter"
                  @click="openUrl('http://fuantest.shouxinfund.com')"
                >
                  进入系统
                </div>
              </div>
            </div>
            <div class="menuBox">
              <div class="menuClickBox">
                <img
                  src="https://video-1316200666.cos.ap-guangzhou.myqcloud.com/fujian/fuan/photo/2.png"
                  alt=""
                  class="menu_img"
                />
                <div class="menu_name">福安茶叶社会化服务平台</div>
                <div class="menu_name_en">
                  Fu'an Tea Socialized Service Platform
                </div>
                <div class="menu_enter">进入系统</div>
              </div>
            </div>
            <div class="menuBox">
              <div class="menuClickBox">
                <img
                  src="https://video-1316200666.cos.ap-guangzhou.myqcloud.com/fujian/fuan/photo/3.png"
                  alt=""
                  class="menu_img"
                />
                <div class="menu_name">智能决策与分析</div>
                <div class="menu_name_en">
                  Intelligent decision and analysis system
                </div>
                <div class="menu_enter" @click="openUrl('http://teaplatform.shouxinfund.com')">进入系统</div>
              </div>
            </div>
            <div class="menuBox">
              <div class="menuClickBox">
                <img
                  src="https://video-1316200666.cos.ap-guangzhou.myqcloud.com/fujian/fuan/photo/4.png"
                  alt=""
                  class="menu_img"
                />
                <div class="menu_name">福安商城</div>
                <div class="menu_name_en">Fu'an Shopping Mall</div>
                <div class="menu_enter" @click="openUrl('https://bicentric-pc.shouxinfund.com')">进入系统</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Main",
  components: {},
  props: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {
    openUrl(url) {
      window.open(url);
    },
  },
};
</script>
<style scoped>
#home {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-image: url(https://video-1316200666.cos.ap-guangzhou.myqcloud.com/fujian/fuan/photo/homebg.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.home-top {
  width: 100%;

  color: #fff;
  font-size: 50px;
  height: 88px;
  line-height: 88px;
  letter-spacing: 1px;
  font-weight: bold;
  background-image: url(https://video-1316200666.cos.ap-guangzhou.myqcloud.com/fujian/fuan/photo/homtitle.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  text-align: center;
}
.home-top .title-top {
  font-size: 42px;
  font-family: Microsoft YaHei;
  color: #ffffff;
  text-stroke: 2px #458e73;
  -webkit-text-stroke: 2px #458e73;
  line-height: 50px;
  padding-top: 10px;
}
.platform-content1 {
  position: absolute;
  left: 0;
  width: 100%;
  height: 57.4%;
  margin-top: 3.8%;
}
.systemContent {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 84%;
  height: 100%;
  margin: 0 auto;
  background-image: url(https://video-1316200666.cos.ap-guangzhou.myqcloud.com/fujian/fuan/photo/homecenter.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.systemContent .sys-content {
  width: 100%;
  height: 100%;
  padding: 1% 9%;
}
.menuBox {
  height: 100%;
  width: 25%;
  float: left;
}
.menuClickBox {
  width: 100%;
  height: 100%;
  cursor: pointer;
  color: #fff;
  text-align: center;
}
.menu_img {
  margin-top: 40px;
  width: 240px;
  height: 220px;
}
.menu_name {
  text-align: center;
  height: 30px;
  font-size: 30px;
  margin-top: 20px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #ffffff;
  text-stroke: 1px #2d4942;
  -webkit-text-stroke: 1px #2d4942;
}
.menu_name_en {
  text-align: center;
  height: 14px;
  font-size: 14px;
  margin-top: 10px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #ffffff;
}
.menu_enter {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #07ffaa;
  width: 220px;
  height: 57px;
  line-height: 57px;
  background: rgba(46, 73, 67, 0.43);
  border: 1px solid #14d9ad;
  border-radius: 57px;

  margin: 40px auto 0;
}
.menu_enter:hover {
  background: #00e5a2;
  border: 1px solid #02e899;
  border-radius: 57px;
  font-size: 14px;
  color: #ffffff;
}
</style>